// stores/user.js
import { defineStore } from 'pinia'
import axios from 'axios'  
import Cookies from 'js-cookie';

export const useUserStore = defineStore('user', {
  state: () => ({
    users: [],
    allUsers: [],
    pagination: {},
    loading: false,
    user: null,
    userId: 0,
    oneUser: null,
  }),
  actions: {
    

    async fetchUser() { 
      this.loading = true
      try {
         const csrf = await axios.get(`https://dscrdc.dscrdc.com/sanctum/csrf-cookie`, {
  withCredentials: true
});
                    if(csrf.data.csrf_cookie){
                        axios.defaults.headers.common['X-XSRF-TOKEN'] = Cookies.get('XSRF-TOKEN');
                        axios.defaults.withCredentials = true;
        const response = await axios.get(`https://dscrdc.dscrdc.com/api/auth`,{
    headers: { 
       Authorization: 'Bearer 2scr2c2@25cre@tedby1sek170l0',
    },
    withCredentials : true
  })
        if (response.status === 200) { 
          if (response.data.user.role === 'admin' || response.data.user.role === 'super_admin' || response.data.user.role === 'member') {
            this.user = response.data.user
          this.userId = response.data.user.id_public
          return 200
          } 
          
        } else {
          this.user = null
          this.userId = 0
          console.log('User not found or not authenticated')
          return 404
        }
        }
        else{
          this.user = null
          this.userId = 0
          console.log('User not found or not authenticated')
          return 404
        }
      } catch (error) {
        
        if (error && error.response && error.response.status ===404) {
          this.userId = 0
          return 404
        }
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async fetchAllUsers(page = 1) {
      this.loading = true
      try {
        const response = await axios.get(`https://dscrdc.dscrdc.com/api/user?page=${page}`, {
    headers: { 
       Authorization: 'Bearer 2scr2c2@25cre@tedby1sek170l0',
    },
    withCredentials : true
  })
        this.allUsers = response.data.data
        this.pagination = response.data
        return true
      } catch (error) {
        console.log('Erreur: '+error)
        return false
      } finally {
        this.loading = false
      }
    },
    async fetchUsers() {
      this.loading = true
      try {
        const response = await axios.get(`https://dscrdc.dscrdc.com/api/useru`, {
    headers: { 
       Authorization: 'Bearer 2scr2c2@25cre@tedby1sek170l0',
    },
    withCredentials : true
  })
        this.users= response.data 
        return true
      } catch (error) {
        console.log('Erreur: '+error)
        return false
      } finally {
        this.loading = false
      }
    },
    async fetchUserById(id) {
      this.loading = true
      try {
        const response = await axios.get(`https://dscrdc.dscrdc.com/api/user/${id}`, {
    headers: { 
       Authorization: 'Bearer 2scr2c2@25cre@tedby1sek170l0',
    },
    withCredentials : true
  })
        if (response.status === 200) {
          this.oneUser = response.data
          return true
        } else {
          console.log('User not found')
          return false
        }
      } catch (error) {
        console.error(error)
        return false
      }
      finally {
        this.loading = false
      }
  },
  

  async deleteuser(id) {
    this.loading = true
    try {
      const csrf = await axios.get(`https://dscrdc.dscrdc.com/sanctum/csrf-cookie`, {
  withCredentials: true
});
                    if(!csrf.data.csrf_cookie) { 
                        throw new Error('CSRF token not received');
                    }
                        axios.defaults.headers.common['X-XSRF-TOKEN'] = Cookies.get('XSRF-TOKEN');
                        axios.defaults.withCredentials = true;
      let response= await axios.delete(`https://dscrdc.dscrdc.com/api/userd/${id}`, {
    headers: { 
       Authorization: 'Bearer 2scr2c2@25cre@tedby1sek170l0',
    },
    withCredentials : true
  })
      if (response.status == 200) {
        return true
       }else{
        return false
       }
    } catch (error) {
      console.log('Erreur: '+error)
      return false
    } finally {
      this.loading = false
    }
      }, 
      async logout() {
        this.loading = true
        try {
          const response = await axios.post(`https://dscrdc.dscrdc.com/api/logout`, {}, {
    headers: { 
       Authorization: 'Bearer 2scr2c2@25cre@tedby1sek170l0',
    },
    withCredentials : true
  })
          if (response.status === 200) {
            this.user = null
            this.userId = 0
            return true
          } else {
            console.log('Logout failed')
            return false
          }
        } catch (error) {
          console.error(error)
          return false
        } finally {
          this.loading = false
        }
      },

}
})
